@if (formGroup().controls.isDaneSzkoly.disabled) {
  <app-info-message
    [labelHTML]="'ustawienia.edycjaCzlonkaRodziny.szkola.zablokowana'"
  >
  </app-info-message>
}
<form [formGroup]="formGroup()">
  <div class="flex items-center gap-1">
    <p-checkbox
      [formControl]="formGroup().controls.isDaneSzkoly"
      [binary]="true"
      [inputId]="'isDaneSzkoly'"
      styleClass="customCheckbox"
    />
    <label [for]="'isDaneSzkoly'" class="ml-2 my-4">Czy dane szkoły?</label>
  </div>
  <div class="grid grid-cols-1 md:grid-cols-2 gap-2">
    <div class="flex flex-col gap-2">
      <label for="name">Nazwa</label>
      <input
        id="name"
        pInputText
        appControlError
        [formControl]="formGroup()!.controls.nazwa"
      />
    </div>
    <div class="flex flex-col gap-2">
      <span id="type">Rodzaj</span>
      <p-select
        ariaLabelledBy="type"
        appControlError
        [options]="rodzajeSzkol()"
        [formControl]="formGroup().controls.rodzaj"
        [showClear]="true"
        optionLabel="nazwa"
        placeholder="Wybierz rodzaj szkoły"
        class="w-full"
        appendTo="body"
        dataKey="id"
        [filter]="true"
        filterBy="nazwa"
        filterPlaceholder="Wyszukaj rodzaj szkoły"
      />
      <app-info-message
        [label]="
            'Rodzaj szkoły wykorzystywany jest tylko w przypadku wypełniania wniosku DS-R (Dobry Start). Jeżeli na liście nie znajduje się rodzaj placówki, do której uczęszcza dziecko, pole powinno pozostać puste.'
          "
      ></app-info-message>
    </div>
  </div>
  <app-form-address
    [formGroup]="formGroup().controls.adres"
    [schoolAddress]="true"
  ></app-form-address>
</form>
